import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation($id: String!) {
    deleteOneWatering(
      where: { id: $id }
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Rega eliminada`, mutationTypes.DELETE)
)

